import SliderEquipments from './SliderEquipments';

export default SliderEquipments;
